/**
 * Standardized date formats used across the application
 * Using moment.js format strings
 */

// Full date and time format: "18th Jan, 2026 10:00 PM"
export const DATE_TIME_FORMAT = 'Do MMM, YYYY hh:mm A';

// Date only format: "18th Jan, 2026"
export const DATE_FORMAT = 'Do MMM, YYYY';

// Time only format: "10:00:00"
export const TIME_FORMAT = 'HH:mm:ss';

// date-fns (not moment) format of a call's time in the Sessions list and
// session detail: "Oct 01, 2026 11:00"
export const SESSION_DATE_TIME_FNS_FORMAT = 'MMM dd, yyyy HH:mm';
